<template>
    <div style="
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        background-color: rgba(0, 0,0, .5);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;
    " >
        <span style="
            min-width: 35px;
            max-width: 35px;
            width: 35px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #212B36;
            background-color: #FFFFFF;
            border-radius: 100%;
            position: absolute;
            left: 16px;
            top: 35px;
        " @click="removePreviewableCartItem"><i class="fal fa-times"></i></span>
        <div style="background-color: transparent; height: 100%; width: 100%" @click.prevent="removePreviewableCartItem"></div>
        <img v-if="previewableCartItem.item.media.length > 0" :src="`${previewableCartItem.item.media[0].url}`" style="width: 100%" />
        <div style="background: white; color: #01AD83; width: 100%; text-align: center; padding-top: 20px" @click.prevent="removePreviewableCartItem" v-if="previewableCartItemFromCart">
            {{ defaultCartLanguage.update_quantity }}
        </div>
        <div style="background: white; padding: 20px; padding-top: 0; width: 100%">
            <div style="display: flex; justify-content: space-between; margin-top: 10px; align-items: flex-start;">
                <h4>{{ findValueFromCode(previewableCartItem.item, 'title', language, defaultLanguage, false) }}</h4>
                <p style="min-width: 50px; text-align: right;">{{ previewableCartItem.price }} €</p>
            </div>
            <div v-if="previewableCartItemFromCart">
                <div style="display: flex; justify-content: center; align-content: center; margin: 30px 0">
                    <button v-if="canHandleQty()" class="btn btn-cart" @click.prevent="removeOneFromCart(previewableCartItemFromCart.item)"
                        :disabled="previewableCartItemFromCart.qty < 2">-</button>
                    <span style="display: flex; justify-content: center; align-content: center; margin: 0 20px; font-size: 22px; height: 100%">{{ previewableCartItemFromCart.qty }}</span>
                    <button v-if="canHandleQty()" class="btn btn-cart" @click.prevent="addOneToCart(previewableCartItemFromCart.item)">+</button>
                </div>
                <div style="margin: 10px;" class="text-center" v-if="previewableCartItemFromCart.qty == 1">
                    <a href="#" @click.prevent="removeCompletely(previewableCartItemFromCart.item)" class="text-danger">{{ defaultCartLanguage.remove_from_order }}</a>
                </div>
            </div>
            <div v-else>
                <div style="display: flex; justify-content: center; align-content: center; margin: 30px 0">
                    <button v-if="canHandleQty()" class="btn btn-cart" @click.prevent="previewableCartItem.qty--" :disabled="previewableCartItem.qty < 2">-</button>
                    <span style="display: flex; justify-content: center; align-content: center; margin: 0 20px; font-size: 22px; height: 100%">{{ previewableCartItem.qty }}</span>
                    <button v-if="canHandleQty()" class="btn btn-cart" @click.prevent="previewableCartItem.qty++">+</button>
                </div>

                <div>
                    <div>
                        <button @click.prevent="addToCart" class="btn btn-success btn-block">{{ defaultCartLanguage.add_to_order }}</button>
                    </div>
                    <div>
                        <div v-if="cartRestaurant && cartRestaurant.uuid !== previewableCartItem.item.restaurant.uuid"><span class="text-danger text-center">{{ defaultCartLanguage.restaurant_mismatch }}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
    props: [
        'findValueFromCode',
        'language',
        'defaultLanguage',
    ],

    methods: {
        ...mapActions(['removePreviewableCartItem', 'addWithQtyToCart', 'addOneToCart', 'removeOneFromCart', 'openCart']),
        escapeIt () {
            console.log('it')
        },
        addToCart () {
            this.addWithQtyToCart(this.previewableCartItem);
            let localPreviewableCartItem = this.previewableCartItem;

            this.removePreviewableCartItem()

            if (!(localPreviewableCartItem.item.restaurant && localPreviewableCartItem.item.restaurant.service_type && localPreviewableCartItem.item.restaurant.service_type.has_basket)) {
                this.openCart();
            }
        },

        removeCompletely (item) {
            this.removeOneFromCart(item)
            this.removePreviewableCartItem()
        },

        canHandleQty() {
            if (this.previewableCartItem.item.restaurant && this.previewableCartItem.item.restaurant.service_type) {
                return this.previewableCartItem.item.restaurant.service_type.can_have_qty;
            } else {
                return true;
            }
        }
    },

    computed: {
        ...mapGetters(['previewableCartItem', 'previewableCartItemFromCart', 'cartRestaurant', 'defaultCartLanguage'])
    }
}

</script>
<style>
    .btn-cart {
        border-radius: 100%!important;
        width: 36px!important;
        background: white!important;
        border: 2px solid #01AD83!important;
        color: #01AD83!important;
        display: flex!important;
        justify-content: center!important;
        align-items: center!important;
        font-size: 20px!important;
    }
</style>
